import { useInfiniteQuery } from "@tanstack/react-query";
import { apiClient } from "@/services/api";
import type { VehicleTimelineEvent } from "@/types";

// PAGE_SIZE for infinite scrolling
const PAGE_SIZE = 10;

interface TimelinePage {
  events: VehicleTimelineEvent[];
  total: number;
}

// Hook that provides paginated timeline events using unified backend endpoint
export function useVehicleTimelineInfinite(vehicleId: string) {
  return useInfiniteQuery<
    TimelinePage,
    Error,
    TimelinePage,
    [string, string],
    number
  >({
    queryKey: ["vehicleTimeline", vehicleId],
    enabled: !!vehicleId,
    initialPageParam: 0,
    queryFn: async ({ pageParam = 0 }) => {
      const { events, total } = await apiClient.getVehicleTimeline(vehicleId, {
        limit: PAGE_SIZE,
        offset: pageParam * PAGE_SIZE,
      });
      return { events, total };
    },
    getNextPageParam: (lastPage, allPages) => {
      const fetchedSoFar = allPages.reduce(
        (sum, p) => sum + p.events.length,
        0,
      );
      if (fetchedSoFar >= lastPage.total) return undefined;
      return allPages.length; // next page index (0-based)
    },
  });
}
